export const ADD_MESSAGE = 'ariaNotification/ADD_MESSAGE';
